module.exports = __webpack_public_path__ + "static/img/s2.06ead45d.png";